import React from 'react';
import { isEmpty as _isEmpty } from "lodash";
import Translation from "../../../../commons/i18n/Translation";


export default class SearchTitle extends React.Component {
    render = () => {
        let msg = !_isEmpty(this.props.query) ?
            Translation.translate("search.results-for", {item: this.props.query}) : Translation.translate("search.results-all");

        return <div className="mywort-search-page__title">
            <h2 className="mywort-heading">
                { msg }
            </h2>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/common/SearchTitle.jsx